'use strict';

wbApp.directive('wbFormAccessPermissionsTypeCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {

        function formatResult(item) {
            if (!item) { return; }

            return $translate.instant(item.text);
        }

        function formatSelection(item) {
            return $translate.instant(item.text);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            replace: true,
            priority: 1,
            link: function (scope, elm, attrs, ctrl) {
               
                ctrl.$parsers.unshift(function (viewValue) {
                    return Number(viewValue);
                });

                ctrl.$formatters.unshift(function (value) {
                    return value + '';
                });

                $timeout(function () {
                    $(elm).select2({
                        minimumResultsForSearch: -1,
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        data: [
                            { id: 0, text: 'TXT_FROM_ACCESS_PERMISSION_TYPE_LOGGED_IN_USERS_ONLY_STUDENT_REQUIRED' },
                            { id: 3, text: 'TXT_FROM_ACCESS_PERMISSION_TYPE_LOGGED_IN_USERS_ONLY_NO_STUDENT' },
                            { id: 2, text: 'TXT_FROM_ACCESS_PERMISSION_TYPE_ALLOW_ANONYMOUS_STUDENT_REQUIRED' },
                            { id: 1, text: 'TXT_FROM_ACCESS_PERMISSION_TYPE_ALLOW_ANONYMOUS_NO_STUDENT' },
                        ]
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                }, 1);
            }
        }
    }]);
